/**
 * 작업PC 의 수집기(127.0.0.1:8788)를 부르는 얇은 클라이언트.
 *
 * 사이트는 Workers 라 대표 PC 의 창을 띄우거나 사무실 방화벽에 붙을 수 없다. 그 일은
 * 이 PC 안에서 도는 작은 서버(`python -m collector serve`)가 하고, 화면 셋(수집 ·
 * 콘솔 · 방화벽 셋팅)이 여기로 부른다. 한 곳에 두는 이유: 주소와 보호 헤더가 세 화면에
 * 따로 살면 하나를 고칠 때 둘이 남는다.
 */

export const AGENT = "http://127.0.0.1:8788";
const GUARD = { "X-Orbit-Agent": "1" };

export interface AgentJob {
  kind: string | null;
  running: boolean;
  ok: boolean | null;
  started_at: string | null;
  finished_at: string | null;
  lines: string[];
  /** 마지막 일의 결과물(SSH 기록·다운로드 목록 등). 종류에 따라 모양이 다르다 */
  result?: unknown;
}

/**
 * 수집기는 **따로 도는 프로그램**이다. 사이트를 새로 배포해도 그 창은 예전 것이 켜져
 * 있을 수 있다. 그래서 필드를 전부 `?` 로 받고, 없으면 없는 대로 그린다.
 */
export interface AgentState {
  account?: string | null;
  keyring_ready?: boolean;
  session_saved?: boolean;
  api_key_set?: boolean;
  secui_base?: string;
  ssh_ready?: boolean;
  job?: AgentJob;
  daily?: { on: boolean; next_at: string | null };
  downloads?: Array<{ name: string; path: string; bytes: number; kind: string }>;
  profiles?: Array<{ id: string; name: string; verified: boolean; steps: number }>;
}

export async function agentGet(): Promise<AgentState> {
  const res = await fetch(`${AGENT}/state`, { headers: GUARD });
  if (!res.ok) throw new Error(`수집기가 ${res.status} 를 돌려줬습니다.`);
  return (await res.json()) as AgentState;
}

export async function agentPost<T = unknown>(path: string, body?: unknown): Promise<T> {
  const res = await fetch(`${AGENT}${path}`, {
    method: "POST",
    headers: body === undefined ? GUARD : { ...GUARD, "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const text = await res.text();
  const parsed = text ? (JSON.parse(text) as T & { error?: string }) : ({} as T & { error?: string });
  if (!res.ok) {
    throw new Error(parsed.error ?? `수집기가 ${res.status} 를 돌려줬습니다.`);
  }
  return parsed;
}
